module.exports = __webpack_public_path__ + "img/pin.9939f27f.svg";